import React from 'react';

import { Panel } from '../common/panel/Panel.component';
import { Button, Colors } from '../legacy/button/Button.component';
import { Input } from '../legacy/input/Input.component';
import styles from './VerifyEmail.module.css';

interface Props {
  resendEmail: (email: string) => void;
  onVerifyPress?: (activationCode: string) => void;
  onClickLogin: () => void;
  email: string;
  error?: string;
}

export const VerifyEmailComponent: React.FC<Props> = props => {
  const [verifyCode, setVerifyCode] = React.useState<string>('');

  const handleVerificationCodeChange = React.useCallback((value: string) => {
    setVerifyCode(value || '');
  }, []);

  return (
    <div className={styles.verification}>
      <Panel title="VERIFY YOUR EMAIL" className={styles.verifyPanel}>
        <div className={styles.panelContainer}>
          <p>
            We have sent the verification email to your email address{' '}
            <span className={styles.email}>{props.email}</span>.
          </p>
          <p>
            If you do not receive the email in the next few minutes, please
            check your spam folder. You can also resend the email.
          </p>
          <p>
            Press the link in the email or copy the verification code from the
            email to the place below.
          </p>
          <Input
            value={verifyCode}
            onChange={handleVerificationCodeChange}
            label="Verification Code"
            className={styles.verifyInput}
            type={3}
          />
          <Button
            color={Colors.COLOR_SCHEME_2}
            className={styles.verifyButton}
            disabled={!verifyCode}
            onClick={() => {
              if (verifyCode) {
                props.onVerifyPress?.(verifyCode);
              }
            }}
          >
            Verify
          </Button>
          <div className={styles.optionsContainer}>
            <Button
              color={Colors.COLOR_SCHEME_4}
              onClick={() => {
                props.resendEmail(props.email);
              }}
            >
              Resend Email
            </Button>
          </div>
        </div>
      </Panel>
      <p className={styles.loginLabel}>Already have an account?</p>
      <Button
        color={Colors.COLOR_SCHEME_3}
        className={styles.loginButton}
        onClick={() => props.onClickLogin()}
      >
        Login
      </Button>
    </div>
  );
};
